export const workTypes = state => state.getIn(['workTypes', 'entities']);
export const workTypeById = (state, id) => workTypes(state).get(String(id));
export const workTypesByIds = (state, ids) => ids.map(id => workTypeById(state, id));
